import React, {Component} from 'react';
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";

var tinycolor = require("tinycolor2");


export default class DefinicjaGodzinyStartowejSelectEkipa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ekipa: null
        };
        this.renderOptionEkipa = this.renderOptionEkipa.bind(this)
        this.onChangeEkipa = this.onChangeEkipa.bind(this)
    }

    componentDidMount(){
     if(Boolean(this.props.obecnaEkipa)){
         this.setState({
             ekipa: this.props.ekipy.find(e=>e.idEk===this.props.obecnaEkipa)
         })
     }
    }

    renderOptionEkipa(option) {
        let color = 'grey';

        if ((tinycolor(option.kolor)).isDark()) {
            color = '#ffffff'
        }
        if ((tinycolor(option.kolor)).isLight()) {
            color = '#000000'
        }

        return (
            <div>
                        <span className={'label label-ebus-default'}
                              style={(option.kolor.length > 1) ? {background: option.kolor, color: color} : {
                                  background: '#f5f5f5',
                                  color: '#333333'
                              }}>
                            {option.kodEk}
                        </span>
                <span style={{marginLeft: '10px'}}>{option.nazwaEk}</span>
            </div>
        )
    }

    onChangeEkipa(e){
        if(e!==null)
        {
            this.props.handleChangeEkipa(e,this.props.rekord)
            this.setState({ekipa:e})
        }
    }

    render() {

        return (
            <div>
                <TopSelect onChange={this.onChangeEkipa} value={this.state.ekipa} options={this.props.ekipy}
                           placeholder={'Brak ekipy - proszę wybrać'} clearable={false}
                           valueKey={'idEk'} labelKey={'kodEk'} valueRenderer={this.renderOptionEkipa} optionRenderer={this.renderOptionEkipa}
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/components/DefinicjaGodzinyStartowejSelectEkipa.js